import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, ActivationEnd, Router} from '@angular/router';
import {FilterData} from '@app/assetfilter/filter.service';
import {InvalidGuid} from "@app/review/models";

import {ReplaySubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';

export class AppState {
    streamId: string;
    filterData: FilterData;
    selection: string[];
    viewingAsset: string;
    assetLink: string;
    reviewAsset: string;

    constructor(init?: Partial<AppState>) {
        Object.assign(this, init);
    }
}

@Injectable({
    providedIn: 'root',
})
export class StateService {
    public state: ReplaySubject<AppState>;
    private _state: AppState;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {
        this.state = new ReplaySubject<AppState>(1);
        this._state = new AppState();

        // FIXME: This is here as the service gets instantiated too late to get the param change.  Seems really dirty
        this.router.events
            .pipe(
                filter((event) => event instanceof ActivationEnd),
                map((event) =>
                    event instanceof ActivationEnd
                        ? event.snapshot
                        : ({} as ActivatedRouteSnapshot),
                ),
            )
            .subscribe((snapshot) => {
                const state = new AppState();
                if (snapshot.params.streamId) {
                    const streamId = snapshot.paramMap.get('streamId');
                    if (streamId) {
                        // Sometimes the query params will get serialized into the review id string from auth0, so we make
                        // sure to just take the guid.  Use the invalid guid constant for a guid length
                        state.streamId = streamId.substring(0, InvalidGuid.length);
                    }
                }
                if (snapshot.queryParams.q) {
                    state.filterData = FilterData.deserialize(snapshot.queryParams.q);
                } else {
                    state.filterData = null;
                }
                if (snapshot.params.linkId) {
                    state.assetLink = snapshot.params.linkId;
                } else {
                    state.assetLink = null;
                }
                // Sometimes the query params will get serialized into these id strings from auth0, so we make
                // sure to just take the guid.  Use the invalid guid constant for a guid length
                state.viewingAsset = snapshot.params.assetId
                    ? snapshot.params.assetId.substring(0, InvalidGuid.length)
                    : null;
                state.reviewAsset = snapshot.params.reviewId
                    ? snapshot.params.reviewId.substring(0, InvalidGuid.length)
                    : null;
                // Change state in a single call
                this.state.next(state);
                this._state = state;
            });
    }

    patchState(key: string, value: any) {
        const state = Object.assign(new AppState(), this._state);
        if (state[key] === value) {
            // Value is unchanged, dont emit a new value
            return;
        }
        state[key] = value;
        this.state.next(state);
        this._state = state;
    }

    clear() {
        const state = new AppState();
        this.state.next(this._state);
        this._state = state;
    }
}
